import { render, staticRenderFns } from "./performance-overview.vue?vue&type=template&id=4f1c897e&"
import script from "./performance-overview.vue?vue&type=script&lang=js&"
export * from "./performance-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports